exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Slide__root {\n  all: initial;\n  font-family: var(--font-family);\n}\n.DS__Slide__root {\n  display: block;\n  margin-right: 6px;\n  margin-left: 6px;\n  overflow: hidden;\n  border-radius: 16px;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Slide__root"
};